export default class Spinner {
    constructor($rootScope) {
        return {
            restrict: 'C',
            controller: ['$rootScope', '$element', ($rootScope, $element) => {
                $rootScope.$on('spinner:start', () => {
                    $element.fadeIn();
                });

                $rootScope.$on('spinner:stop', () => {
                    $element.fadeOut();
                });
            }]
        }
    }
}

Spinner.$inject = ['$rootScope'];
